import React from 'react';
import SupersizeMyEditComponent from '../components/SupersizeMyEdit';
import { AddonsContextConsumer } from '../../../../context/AddonsContext';

function SupersizeMyEdit(props) {
  return (
    <AddonsContextConsumer>
      {({ constants: { SUPERSIZE_MY_EDIT } }) =>
      <SupersizeMyEditComponent
        {...props}
        // $FlowFixMe Cannot call SUPERSIZE_MY_EDIT because undefined [1] is not a function.
        SUPERSIZE_MY_EDIT={SUPERSIZE_MY_EDIT('SUPERSIZE_MY_EDIT')} />}


    </AddonsContextConsumer>);

}

export default SupersizeMyEdit;